import PropTypes from "prop-types";
import React from "react";
import { Box } from "@mantine/core";
import { useStylesLanding } from "../../utils/mantine/useStylesLanding";

const GuaranteedDataBlock = ({ children, textRight = false }) => {
  const { classes: landingClasses } = useStylesLanding();
  return (
    <Box
      className={`${landingClasses.guaranteedBlocksItemContent} ${
        textRight ? landingClasses.guaranteedBlocksItemContentTextRight : ""
      }`}
    >
      <Box className="border-top"></Box>
      <Box className="border-bottom"></Box>
      <Box className="border-left"></Box>
      <Box className="border-right"></Box>
      <Box className="scalloped-top"></Box>
      <Box className="scalloped-bottom"></Box>
      <Box className="scalloped-left"></Box>
      <Box className="scalloped-right"></Box>
      {children}
    </Box>
  );
};
GuaranteedDataBlock.propTypes = {
  children: PropTypes.string.isRequired,
  textRight: PropTypes.bool,
};
export default GuaranteedDataBlock;
